import React from 'react';
import { Link } from 'react-router-dom';
import { Home, ArrowLeft } from 'lucide-react';

const NotFound = () => {
  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '100vh', backgroundColor: '#faf8f5', padding: '20px' }}>
      <div style={{ textAlign: 'center', maxWidth: '500px' }}>
        <div style={{ fontSize: '6rem', fontWeight: 700, color: '#D4AF37', fontFamily: 'Playfair Display, serif', lineHeight: 1, marginBottom: '16px' }}>
          404
        </div>
        <h2 style={{ fontFamily: 'Playfair Display, serif', fontWeight: 600, color: '#1A1A1A', marginBottom: '12px' }}>
          Page Not Found
        </h2>
        <p style={{ color: '#999', fontSize: '1rem', marginBottom: '32px', lineHeight: 1.8 }}>
          The page you're looking for doesn't exist or has been moved. 
          Let's get you back to something delicious.
        </p>
        <div style={{ display: 'flex', gap: '12px', justifyContent: 'center', flexWrap: 'wrap' }}>
          <Link to="/" className="btn btn-gold d-flex align-items-center gap-2" style={{ padding: '14px 32px' }}>
            <Home size={18} /> Go Home
          </Link>
          <button onClick={() => window.history.back()} className="btn btn-outline-gold d-flex align-items-center gap-2" style={{ padding: '14px 32px' }}>
            <ArrowLeft size={18} /> Go Back
          </button>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
